import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
   actionModalContent: null,
};

const actionModalSlice = createSlice({
   name: 'actionModalData',
   initialState,
   reducers: {
      setActionModalContent(state, action) {
         state.actionModalContent = action.payload;
      },
      resetActionModalContent() {
         return { ...initialState };
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => initialState);
   },
});

export const { setActionModalContent, resetActionModalContent } = actionModalSlice.actions;
export default actionModalSlice.reducer;
